/*
 * Convert cents model value to dollar input value
 */
import Cents from 'goodeggs-money';

export default __filename;
angular.module(__filename, []).directive(
  'inputCents',
  ngInject(() => ({
    restrict: 'A',
    scope: {},
    require: 'ngModel',
    link(scope, element, attrs, ngModelCtrl) {
      ngModelCtrl.$formatters.push(function(cents) {
        if (cents == null) {
          cents = 0;
        }
        return new Cents(cents).toDollars();
      });

      ngModelCtrl.$parsers.push(function(dollarsString) {
        const dollars = Number(dollarsString) != null ? Number(dollarsString).toFixed(2) : 0;
        return Cents.fromDollars(dollars).toNumber();
      });
    },
  })),
);
